<template>
  <section v-if="blogEntry" class="blog-img">
    <img
      :src="blogEntry.Image"
      :alt="blogEntry.Title"
      class="blog-image"
      style="max-height: 600px; object-fit: cover; object-position: center"
    />
  </section>

  <section
    v-if="blogEntry"
    class="full-width-image-section white-pattern white-sep text-center"
  >
    <div class="container">
      <div class="blog-section">
        <h2 class="heading">{{ blogEntry.Title }}</h2>
        <h6>{{ new Date(blogEntry.PostDate).toLocaleDateString() }}</h6>
        <p>{{ blogEntry.News }}</p>
      </div>
    </div>
  </section>

  <section class="signup-section pt-5 pb-5">
    <div class="container">
      <div class="row g-0">
        <div
          class="col-md-6 d-flex flex-column justify-content-center signup-image-column text-white p-5 mt-5 mb-lg-5"
        >
          <h2 class="signup-header">Wicklow Trails</h2>
          <p class="signup-text">
            Sign up for our newsletter to stay updated on our walks, trails, and
            more!
          </p>
        </div>

        <div class="col-md-6 bg-white">
          <h2 class="signup-form-header text-white p-3 text-center">Sign Up</h2>
          <div class="px-5 pt-3 pb-5 pt-md-5">
            <form>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Your name"
                />
              </div>
              <div class="mb-3">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Your email"
                />
              </div>
              <div class="mb-3">
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="Message"
                ></textarea>
              </div>
              <button type="submit" class="btn w-100">Send</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="full-width-image-section footer green-sep"></section>
</template>

<script>
import db from "@/db"; // Import the IndexedDB database

export default {
  props: ["id"],
  data() {
    return {
      updates: [],
      blogEntry: null,
    };
  },
  async mounted() {
    await this.fetchUpdates();
  },
  methods: {
    async fetchUpdates() {
      try {
        const customerId = localStorage.getItem("tenantId");
        const base64Credentials = btoa("Ian:Ennistymon1!");
        const baseURL = process.env.VUE_APP_API_BASE_URL;
        const url = `${baseURL}VisitorCard/GetNews`;

        // Set timeout to avoid long hangs
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            CustomerId: customerId,
            Authorization: `Basic ${base64Credentials}`,
          },
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error("Failed to fetch updates.");
        }

        const updatesData = await response.json();
        this.updates = updatesData;

        // Save updates to IndexedDB
        if (db.tables.find(table => table.name === "news")) {
          await db.news.clear();
          await db.news.bulkPut(updatesData);
        }
      } catch (error) {
        console.warn("Fetching news failed, loading offline data:", error);
        this.updates = await db.news.toArray(); // Fallback to local data
      }

      // Find the specific blog entry after updates are loaded
      this.findBlogEntry();
    },
    findBlogEntry() {
      if (!this.updates.length) return;
      this.blogEntry = this.updates.find(
        update => update.Id === parseInt(this.id)
      );
    },
  },
};
</script>

<style>
.full-width-image-section.white-pattern {
  background-image: none;
  background-color: #fff;
  padding-bottom: 70px;
}
</style>
